import * as Types from '../types-api.generated';

import { DropFragment, UserLightFragment, MediaFragment, DropSaleConfigurationFragment, MomentStatsFragment, EditionSaleConfigurationFragment, WorldOverviewFragment, EditionFragment, SplitFragment, MomentOverviewFragment, MomentFragment, WorldOverviewOnExhibition } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiDropVariables = Types.Exact<{
  chainId: Types.Scalars['ChainId'];
  contractAddress: Types.Scalars['Address'];
}>;


export type ApiDrop = { drop: { brandColor: string | null, chainId: ChainId, clearingPrice: number | null, collectionImageUrl: string | null, contractAddress: Address, contractType: Types.ApiContractType, coverImageUrl: string | null, description: string | null, earlyAccessStartTime: string | null, endTime: string | null, generalAvailabilityStartTime: string | null, id: string, isRevealed: boolean | null, lastMintedAt: string | null, minPrice: number | null, mintPrice: number | null, moderationFrom: string | null, moderationStatus: Types.ApiModerationStatus, name: string, nftCount: number, saleType: Types.ApiCollectionSaleType | null, slug: string, symbol: string, worldId: number | null, status: Types.ApiDropAvailabilityStatus, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, saleConfiguration: { __typename: 'FixedPriceSaleConfiguration', maxTokenId: number, mintPrice: number, presaleStartTime: string | null, startTime: string, fndFixedPriceSaleStatus: Types.ApiFixedPriceStatus } | { __typename: 'HighlightFixedPriceSaleConfiguration', highlightId: string, mintPrice: number, startTime: string, optionalEndTime: string | null, optionalMaxTokenId: number | null, vectorId: number, highlightFixedPriceSaleStatus: Types.ApiHighlightFixedPriceStatus } | { __typename: 'HighlightLinearDutchAuctionSaleConfiguration' } | { __typename: 'HighlightStaggeredDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, highlightId: string, mintVectorId: string, maxPrice: number, maxTokenId: number, minPrice: number, mintEndTime: string | null, startTime: string, highlightStaggeredDutchAuctionStatus: Types.ApiHighlightDutchAuctionStatus, prices: Array<{ endTime: string, price: number }> } | { __typename: 'LinearDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, maxPrice: number, maxTokenId: number, minPrice: number, startTime: string, fndLinearDutchAuctionStatus: Types.ApiDutchAuctionStatus } | null } | null };



export const ApiDropDocument = /*#__PURE__*/ `
    query Drop($chainId: ChainId!, $contractAddress: Address!) {
  drop(by: {collection: {chainId: $chainId, contractAddress: $contractAddress}}) {
    ...DropFragment
  }
}
    ${DropFragment}
${UserLightFragment}
${MediaFragment}
${DropSaleConfigurationFragment}`;

export const useDrop = <
      TData = ApiDrop,
      TError = ClientError
    >(
      variables: ApiDropVariables,
      options?: Omit<UseQueryOptions<ApiDrop, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiDrop, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiDrop, TError, TData>(
      {
    queryKey: ['Drop', variables],
    queryFn: apiFetcher<ApiDrop, ApiDropVariables>(ApiDropDocument, variables),
    ...options
  }
    )};

useDrop.getKey = (variables: ApiDropVariables) => ['Drop', variables];

export const useInfiniteDrop = <
      TData = InfiniteData<ApiDrop>,
      TError = ClientError
    >(
      variables: ApiDropVariables,
      options: Omit<UseInfiniteQueryOptions<ApiDrop, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiDrop, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiDrop, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Drop.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiDrop, ApiDropVariables>(ApiDropDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteDrop.getKey = (variables: ApiDropVariables) => ['Drop.infinite', variables];


useDrop.fetcher = (variables: ApiDropVariables, options?: RequestInit['headers']) => apiFetcher<ApiDrop, ApiDropVariables>(ApiDropDocument, variables, options);
